import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuGetService } from '../../services';

export const fetchMenuGet = createAsyncThunk(
    'menuGet/fetchMenuGet',
    async ({ id }) => {
        const response = await MenuGetService(id)
        return response.result;
    }
);

const menuGetSlice = createSlice({
    name: 'menuGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuGetSlice.reducer;
